import { Button, Divider, Flex, Modal, Typography } from "antd";
import { type ReactNode, useState } from "react";
import FormHelpSectionLabelView, { type FormSectionLabel } from "./FormHelpSectionLabelView";
import "./FormHelpSection.scss";

type Props = {
  sectionTitle?: ReactNode;
  modalTitle: ReactNode;
  modalSubTitle?: ReactNode;
  fields: FormSectionLabel[];
};

export const FormHelpSection = ({ sectionTitle, modalTitle, modalSubTitle, fields }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Flex align="center" justify={sectionTitle ? "space-between" : "flex-end"} className="form-help-section">
      {sectionTitle && <Typography.Text className="form-help-section-title">{sectionTitle}</Typography.Text>}
      <Modal
        width={750}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title={
          <Flex align="center" gap="small" className="form-help-section-modal-title">
            <i className="fa-regular fa-circle-question" />
            {modalTitle}
          </Flex>
        }
        footer={null}
      >
        {modalSubTitle && (
          <>
            <Typography.Text>{modalSubTitle}</Typography.Text>
            <Divider className="form-help-section-info-modal-divider" />
          </>
        )}
        <div className="form-help-section-info-modal-container">
          {fields.map((field) => (
            <FormHelpSectionLabelView key={field.titleIntlKey} {...field} />
          ))}
        </div>
      </Modal>
      <Button icon={<i className="fa-regular fa-circle-question" />} type="text" size="small" onClick={() => setIsModalOpen(true)} />
    </Flex>
  );
};
